/* eslint-disable */
(function (d, b, i) {
  var f = d.getElementsByTagName(b)[0],
    j = d.createElement(i);
  j.name = 'google-site-verification';
  j.content = '-P0xp1AIRsIDKZziDM977JV2Cf5GwUL8eqZSU_Dr0Bc';
  f.appendChild(j);
})(document, 'head', 'meta');
/* eslint-enable */
